// AdminContext.js — shim de compatibilité → délègue vers AuthContext
// Les composants admin existants (AdminDashboard, etc.) continuent de fonctionner sans modification.
import React from 'react';
import { useAuth, ROLES, isAdminSideRole } from './AuthContext';
import { hasPermission } from '../config/rolePermissions';

// No-op : AuthProvider est monté directement dans App.js
export const AdminProvider = ({ children }) => <>{children}</>;

export const useAdmin = () => {
  const auth  = useAuth();
  // Le panel est accessible aux admins ET aux rôles staff (chef d'agence + agents).
  const isPanelRole = isAdminSideRole(auth.role);
  const u     = isPanelRole ? auth.user : null;
  const roles = u?.roles || [];
  const company_id = u?.company_id ?? null;
  const agence_id  = u?.agence_id ?? null;

  const hasRole      = (...requiredRoles) => roles.some(r => requiredRoles.includes(r)) || auth.role === ROLES.SUPER_ADMIN;
  const hasExactRole = (...requiredRoles) => requiredRoles.every(r => roles.includes(r)) || auth.role === ROLES.SUPER_ADMIN;
  // Permission UI (la sécurité réelle reste backend). Les admins ont 'all'.
  const can = (permission) => {
    if (auth.role === ROLES.SUPER_ADMIN || auth.role === ROLES.ADMIN_COMPANY) return true;
    return hasPermission(roles, permission);
  };

  const rbac = {
    isSuperAdmin:   auth.role === ROLES.SUPER_ADMIN,
    isAdminCompany: auth.role === ROLES.ADMIN_COMPANY,
    isStaff:        auth.role === ROLES.STAFF,
    isDriver:       auth.role === ROLES.DRIVER,
    isOperator:     roles.includes('OPERATOR'),
    isChefAgence:   roles.includes('CHEF_AGENCE'),
    roles,
    company_id,
    agence_id,
    hasRole,
    hasExactRole,
    can,
  };

  return {
    admin:           u,
    isAuthenticated: auth.isAuthenticated && isPanelRole,
    loading:         auth.loading,
    login:           auth.login,
    logout:          auth.logout,
    // RBAC plat (utilisé directement par les composants)
    isSuperAdmin:   rbac.isSuperAdmin,
    isAdminCompany: rbac.isAdminCompany,
    isStaff:        rbac.isStaff,
    isDriver:       rbac.isDriver,
    isOperator:     rbac.isOperator,
    isChefAgence:   rbac.isChefAgence,
    roles,
    company_id,
    agence_id,
    hasRole,
    hasExactRole,
    can,
    // Objet rbac groupé (utilisé par AdminDashboard)
    rbac,
  };
};
